/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_TInputs */

const en_mk_tut_tim_t = /** @type {(inputs: Mk_Tut_Tim_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviting your team and setting roles`)
};

const id_mk_tut_tim_t = /** @type {(inputs: Mk_Tut_Tim_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengundang tim dan mengatur peran`)
};

/**
* | output |
* | --- |
* | "Inviting your team and setting roles" |
*
* @param {Mk_Tut_Tim_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_t = /** @type {((inputs?: Mk_Tut_Tim_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_t(inputs)
	return en_mk_tut_tim_t(inputs)
});